/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:97bd032c-101a-40a7-8fc0-199601feb19a",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_h9VtK087j",
    "aws_user_pools_web_client_id": "q38ekqllqds2k7gjnj25u1hoa",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://wznckfdlqzd2pn3zv5pq5ofu7m.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "getting-focused-app8f2a44aef3d94c779d88812fe73bapp-main",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
